"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataControllers are used to support basic data actions like to and from json decorators.
 */
const exceptions_1 = require("../exceptions");
class DataPropertyModifiers {
    constructor(mapFunction, merge) {
        this.mapFunction = mapFunction;
        this.merge = merge;
    }
    shouldMerge() {
        return this.merge;
    }
    getMapFunction() {
        return this.mapFunction;
    }
}
class DataController {
    constructor() {
        // TODO: this should be private, but is problematic in f.e. DistributorAPI - "Types have separate declarations of a private property" - probably https://github.com/Microsoft/TypeScript/issues/8346
        this.dataPropertyKeys = new Map();
    }
    /**
     * Decorator
     *
     * Usage example:
     * ```@DataController.dataProperty((x)=>x.toUpperCase())```
     *
     * @param {Function} mapFunction : A value manipulation or mapping function can be added, optional.
     * @returns {(target: DataController, propertyKey: string) => void}
     */
    static dataProperty(mapFunction) {
        return (target, propertyKey) => {
            DataController.makePropertyMapper(target, propertyKey, new DataPropertyModifiers(mapFunction, false));
        };
    }
    static mergedDataProperty(mapFunction) {
        return (target, propertyKey) => {
            if (mapFunction === undefined) {
                mapFunction = (x) => __awaiter(this, void 0, void 0, function* () {
                    if (x.asDict !== undefined) {
                        return yield x.asDict();
                    }
                    else {
                        return x;
                    }
                });
            }
            DataController.makePropertyMapper(target, propertyKey, new DataPropertyModifiers(mapFunction, true));
        };
    }
    static makePropertyMapper(prototype, key, dpm) {
        // Adaptation, inspiration from http://romkevandermeulen.nl/2018/01/24/typescript-property-decorators.html
        const values = new Map();
        Object.defineProperty(prototype, key, {
            set(firstValue) {
                // On object instantiation when property is first set on the instance?
                Object.defineProperty(this, key, {
                    get() {
                        return values.get(this);
                    },
                    set(value) {
                        values.set(this, value);
                    },
                    enumerable: true,
                });
                this.dataPropertyKeys.set(key, dpm);
                this[key] = firstValue;
            },
            configurable: true,
            enumerable: true,
        });
    }
    asDict() {
        return __awaiter(this, void 0, void 0, function* () {
            let dictResult = {};
            for (const [key, dpm] of this.dataPropertyKeys) {
                let v = this[key];
                if (dpm.getMapFunction() !== undefined) {
                    v = yield dpm.getMapFunction()(v);
                }
                else if (v.asDict !== undefined) {
                    v = yield v.asDict();
                }
                if (dpm.shouldMerge()) {
                    dictResult = Object.assign(Object.assign({}, dictResult), v);
                }
                else {
                    dictResult[key] = v;
                }
            }
            return dictResult;
        });
    }
    clone() {
        // TODO: make clone an abstract method
        // TODO: do we have to clone the dataPropertyKeys as well?
        console.error("Clone not implemented");
        throw exceptions_1.NOT_IMPLEMENTED_EXCEPTION;
    }
    isValid() {
        // TODO: make isValid an abstract method
        throw exceptions_1.NOT_IMPLEMENTED_EXCEPTION;
    }
}
exports.default = DataController;
//# sourceMappingURL=DataController.js.map